import { useForm } from '@tanstack/react-form';
import { Announcement03 } from '@untitled-ui/icons-react';

import { Button } from '../components/buttons/button';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from '../components/dialog';
import { FeaturedIcon } from '../components/featured-icon';
import { TextField } from '../components/inputs/text-field';
import { brandCreateSchema } from '../entity/api/brand';
import { tGlobal, tNamespace } from '../services/translation';
import { parseFirstZodError } from '../shared/validation';

const t = tNamespace('app.settings.organization.brands');

export function AddBrandDialog(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddBrand: (data: { name: string; websiteUrl: string }) => void;
}) {
  const { open, onOpenChange, onAddBrand } = props;

  const form = useForm({
    defaultValues: {
      name: '',
      websiteUrl: '',
    },
    onSubmit: function (data) {
      const { name, websiteUrl } = data.value;
      onAddBrand({ name, websiteUrl });
      form.reset();
      void onOpenChange(false);
    },
  });

  const handleCloseDialog = () => {
    form.reset();
    void onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleCloseDialog}>
      <DialogContent hasCloseButton>
        <div className="mb-5 flex w-full">
          <FeaturedIcon icon={<Announcement03 />} color="accent" border={false} />
        </div>
        <DialogTitle>{t('newBrand')}</DialogTitle>
        <div className="mt-5">
          <form className="flex w-full flex-col gap-4">
            <form.Field
              name="name"
              validators={{
                onChange: function (data) {
                  return parseFirstZodError(brandCreateSchema.shape.name, data.value);
                },
              }}
              // eslint-disable-next-line react/no-children-prop
              children={function (field) {
                return (
                  <TextField
                    label={t('brandNameLabel')}
                    placeholder={t('brandNamePlaceholder')}
                    sizeField="lg"
                    className="w-full"
                    value={field.state.value}
                    onChange={function (e) {
                      field.handleChange(e.target.value);
                    }}
                    error={field.state.meta?.errors}
                  />
                );
              }}
            />

            <form.Field
              name="websiteUrl"
              validators={{
                onChange: function (data) {
                  return parseFirstZodError(brandCreateSchema.shape.companyWebsite, data.value);
                },
              }}
              // eslint-disable-next-line react/no-children-prop
              children={function (field) {
                return (
                  <TextField
                    label={t('brandWebsiteLabel')}
                    placeholder={t('brandWebsitePlaceholder')}
                    sizeField="lg"
                    className="w-full"
                    value={field.state.value}
                    onChange={function (e) {
                      field.handleChange(e.target.value);
                    }}
                    error={field.state.meta?.errors}
                  />
                );
              }}
            />
          </form>
        </div>
        <DialogFooter>
          <Button size="xl" variant="outline" className="w-full" onClick={handleCloseDialog}>
            {tGlobal('cancel')}
          </Button>
          <Button
            size="xl"
            variant="accent"
            className="w-full"
            onClick={function () {
              void form.handleSubmit();
            }}
          >
            <p className="whitespace-nowrap">{tGlobal('save')}</p>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
